import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { storageKeys } from 'settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StorageHandler } from 'C4';

const StoreButtons = (props) => {
  const { title } = props;

  const [appleStore, setApple] = useState(null);
  const [googlePlay, setGoogle] = useState(null);

  const getAppInfo = async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      setApple(appInfo.appleStore);
      setGoogle(appInfo.googlePlay);
    }
  };

  useEffect(() => {
    getAppInfo();
  });

  return (
    <React.Fragment>
      {title && <h3>Get the app on your mobile device</h3>}
      <div className="storeButtons__container">
          <a href="https://apps.apple.com/app/lauderdale-local/id6753805898" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={['fab', 'app-store']} />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.lauderdaleambassador" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={['fab', 'google-play']} />
          </a>
      </div>
    </React.Fragment>
  );
};

export default StoreButtons;

StoreButtons.propTypes = {
  title: PropTypes.bool,
};

StoreButtons.defaultProps = {
  title: false,
};
